import { PrinterBuilder } from './printer-builder';
import { Paydesk } from './../model/paydesk';
export class PaydeskBuilder {
    static buildPaydesk(data) {
        let paydesk = new Paydesk();
        paydesk.id = data.id;
        paydesk.id_lot = data.id_lot;
        paydesk.name = data.name;
        paydesk.active = data.active;
        paydesk.printers = data.printers ? data.printers.map(printer => PrinterBuilder.buildPrinter(printer)) : [];
        return paydesk;
    }
}
//# sourceMappingURL=paydesk-builder.js.map